import { Button, Modal } from '@sainsburys-tech/bolt'
import styled, { css } from 'styled-components'

const GalleryModal = styled(Modal)`
  max-width: 100vw;
  max-height: 100vh;
  height: 100%;
  width: 100%;
  padding: 0;
  background: none;
  box-shadow: none;
  pointer-events: none;
  overflow: hidden;
  z-index: 102;
  position: fixed;
  > [data-test='gallery-modal-overlay'] {
    background-color: ${props => props.theme.color.monochrome.black};
    opacity: ${props => props.theme.modifier.opacity[90]};
  }
`

const GalleryModalButton = styled(Button)`
  background-color: ${props => props.theme.color.monochrome.dark};
  flex-shrink: 0;

  ${props =>
    !props.disabled &&
    css`
      &:hover,
      &:focus {
        background-color: ${props.theme.color.monochrome.base};
      }

      &:active {
        background-color: ${props.theme.color.palette['grey-50']};
      }
    `}

  ${props =>
    props.isZoomedIn &&
    css`
      position: absolute;
      z-index: 1;
      ${props['data-test'] === 'gallery-modal-next-button' ? 'right: 40px;' : 'left: 40px;'};
    `}
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    &.gallery-modal-nav-button {
      display: none;
    }
  }
`
const GalleryModalHeader = styled.aside`
  background-color: ${props => props.theme.color.monochrome.darker}80;
  color: ${props => props.theme.color.content.white};
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
  align-items: center;
  pointer-events: auto;
  height: 48px;
`

const GalleryModalHeaderButtonContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.size.space[4]};
`
const GalleryModalContentArea = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  height: inherit;
  width: inherit;
  gap: 20px;
  padding: 20px 40px;
  overflow: hidden;

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    padding: 20px 0;
  }

  > div {
    padding: unset;
    > * {
      pointer-events: auto;
    }
  }

  * > picture {
    pointer-events: none;
    > * {
      pointer-events: auto;
    }
  }

  > button {
    pointer-events: auto;
  }
`

const ThumbnailWrapper = styled.div`
  width: 100%;
  pointer-events: all;
  ${props =>
    props.isPortrait &&
    css`
      display: block;
      position: relative;

      @media only screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    `}
`

export {
  ThumbnailWrapper,
  GalleryModal,
  GalleryModalButton,
  GalleryModalHeader,
  GalleryModalHeaderButtonContainer,
  GalleryModalContentArea
}
